import { defineComponent, computed, PropType } from 'vue'
import { Direction, SpaceSize, Align } from '../../enums'

export default defineComponent({
  props: {
    direction: {
      type: String as PropType<Direction>,
      default: 'horizontal',
    },
    size: {
      type: [String, Number] as PropType<SpaceSize | string | number>,
      default: 'default',
    },
    align: {
      type: String as PropType<Align>,
      default: 'center',
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { slots }) {
    const isStandardSize = computed(
      () => typeof props.size === 'string' && ['small', 'default', 'large'].includes(props.size),
    )

    return () => <div class={
      [
        'd-space',
        `d-space-${props.direction}`,
        isStandardSize.value && `d-space-${props.size}`,
        props.align !== 'unset' && `d-space-align-${props.align}`,
        props.wrap && 'd-space-wrap',
        props.block && 'd-space-block',
      ]
    }
    style={
      !isStandardSize.value && {
        gap: typeof props.size === 'number'
          ? `${props.size}px`
          : props.size,
      }
    }
    >
      {slots.default?.() || []}
    </div>
  },
})
